export default class  SettlementSalesActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_CASHFLOW='GET_HELPER_CASHFLOW';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static PRINT_CASHFLOW='PRINT_CASHFLOW';
  static BEFORE_PRINT_CASHFLOW='BEFORE_PRINT_CASHFLOW';

  static submit(){
    return {
      type:  SettlementSalesActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type:  SettlementSalesActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type:  SettlementSalesActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type:  SettlementSalesActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type:  SettlementSalesActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type:  SettlementSalesActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type:  SettlementSalesActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type:  SettlementSalesActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type:  SettlementSalesActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type:  SettlementSalesActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type:  SettlementSalesActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type:  SettlementSalesActions.GET_HELPER_CASHFLOW,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type:  SettlementSalesActions.ERROR_SERVER,
      payload: error
    };
  } 
  static beforePrint(){
    return {
      type: SettlementSalesActions.BEFORE_PRINT_CASHFLOW,
    };
  }
  static print(printSettlementSales){
    return {
      type: SettlementSalesActions.PRINT_CASHFLOW,
      payload: printSettlementSales
    };
  }
}